import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b2021a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "products" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "body-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "body-showcase"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-card-image" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item-card-label" }
const _hoisted_10 = { class: "item-card-description" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "body-showcase body-placeholders-showcase"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.h1Text) + " ", 1),
        _hoisted_4
      ]),
      _createVNode(_TransitionGroup, { name: "list" }, {
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "item-card",
                    onClick: ($event: any) => (_ctx.goToDesign(item))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        src: 
                  item.preview
                    ? item.preview
                    : require(`@/assets/img/products/${item.alias}.png`)
                ,
                        alt: ""
                      }, null, 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createTextVNode(" Min " + _toDisplayString(item.minQuantity) + " units ", 1),
                      _hoisted_11,
                      _createTextVNode(" Prices start from $" + _toDisplayString(item.minPrice) + " + GST ", 1),
                      _hoisted_12,
                      _createElementVNode("span", null, "Production time: " + _toDisplayString(item.settings.productionTime || "N/A"), 1)
                    ])
                  ], 8, _hoisted_6))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(8, (item) => {
                  return _createVNode(_component_Skeleton, {
                    key: item,
                    class: "placeholder"
                  })
                }), 64))
              ]))
        ]),
        _: 1
      })
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Footer, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}